import styled from 'styled-components';

import { CircleButton } from '@pkg/components/TwitterConnect/styles';

export const Wrapper = styled.div`
    width: 100%;
`;

export const CloseButton = styled(CircleButton)`
    top: 40px;
    right: 40px;
    left: unset;

    z-index: 9;

    @media (max-width: 768px) {
        top: 20px;
        right: 20px;
    }
`;
